module.exports = __webpack_public_path__ + "img/ic_wusousuo@3x.ae4488f7.png";